// extracted by mini-css-extract-plugin
module.exports = {"banner":"style__banner__QegAg","isBgColoredSmScreen":"style__isBgColoredSmScreen__bhQK6","isBgColoredLgScreen":"style__isBgColoredLgScreen__myopp"};